import React from 'react';
import TutoringSelfServeViewGetStartedUnauthenticated, {
  Props as GetStartUnauthenticatedProps,
} from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewGetStartedUnauthenticated';
import {
  getStudentDetails,
  getAvailabilityQuery,
  getReservationInfo,
  getUnauthedPurchaserDetails,
  getSelectedSubjectOrThrow,
  getPurchaseResult, throwIfNullish, throwIfEmpty,
} from 'lib/TutoringStateMachine/TutoringDataHelpers';
import TutoringSelfServeViewStudentDetailsUnauthenticated, {
  Props as StudentDetailsUnauthenticatedProps,
} from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewStudentDetailsUnauthenticated';
import TutoringSelfServeViewGetStartedAuthenticated, {
  Props as GetStartedAuthenticatedProps,
} from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewGetStartedAuthenticated/TutoringSelfServeViewGetStartedAuthenticated';
import TutoringSelfServeViewSchedule, {
  Props as ScheduleProps,
} from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewSchedule/TutoringSelfServeViewSchedule';
import TutoringSelfServeViewLinkStudent, {
  Props as LinkStudentProps,
} from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewLinkStudent';
type WithoutRestored<T> = Omit<T, 'restoredProps'>;

export function RestoredGetStartedUnauthenticated(
  props: WithoutRestored<GetStartUnauthenticatedProps>
) {
  const unauthedPurchaserDetails = getUnauthedPurchaserDetails();
  return (
    <TutoringSelfServeViewGetStartedUnauthenticated
      {...props}
      restoredProps={{
        unauthedPurchaserDetails,
      }}
    />
  );
}

export function RestoredGetStartedAuthenticated(
  props: WithoutRestored<GetStartedAuthenticatedProps>
) {
  const authedStudentDetails = getStudentDetails();
  return (
    <TutoringSelfServeViewGetStartedAuthenticated
      {...props}
      restoredProps={{
        authedStudentDetails,
      }}
    />
  );
}

export function RestoredStudentDetailsUnauthenticated(
  props: WithoutRestored<StudentDetailsUnauthenticatedProps>
) {
  const studentDetails = getStudentDetails();
  const unauthedPurchaserDetails = throwIfNullish(getUnauthedPurchaserDetails());
  return (
    <TutoringSelfServeViewStudentDetailsUnauthenticated
      {...props}
      restoredProps={{
        unauthedPurchaserDetails,
        studentDetails,
      }}
    />
  );
}

export function RestoredSchedule(props: WithoutRestored<ScheduleProps>) {
  const reservationInfo = getReservationInfo();
  const availabilityQuery = getAvailabilityQuery();
  const selectedSubject = getSelectedSubjectOrThrow();
  return (
    <TutoringSelfServeViewSchedule
      {...props}
      restoredProps={{
        reservationInfo,
        availabilityQuery,
        selectedSubject,
      }}
    />
  );
}

export function RestoredLinkStudent(props: WithoutRestored<LinkStudentProps>) {
  const linkStudentToken = getPurchaseResult()?.linkStudentToken;
  return (
    <TutoringSelfServeViewLinkStudent
      {...props}
      restoredProps={{
        linkStudentToken: linkStudentToken ?? "",
      }}
    />
  );
}
